import { Component, OnInit } from '@angular/core';
import {EquipmentService} from '@shared/services/maintenance/equipment.service';
import {tap} from 'rxjs/operators';
import {ActivatedRoute} from '@angular/router';
import {OpenInfoEquipment} from '@shared/models/maintenance/open-info-equipment.model';

@Component({
    selector: 'saf-open-info-equipment',
    templateUrl: './open-info-equipment.component.html',
    styleUrls: ['./open-info-equipment.component.scss'],
    standalone: false
})
export class OpenInfoEquipmentComponent implements OnInit {
  public equipmentId: number;
  public openInfoEquipment: OpenInfoEquipment = null;
  public loading = false;

  constructor(
    private equipmentService: EquipmentService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.equipmentId = +this.route.snapshot.paramMap.get('id');
    this.loadForm();
  }

  loadForm() {
    this.loading = true;

    this.equipmentService.getOpenInfoEquipment({equipmentId: this.equipmentId})
      .pipe(tap(() => this.loading = false))
      .subscribe((result) => {
        if (result) {
          this.openInfoEquipment = result;
        }
      });
  }
}
